import { useStore as useInventorizeStore } from 'routes/inventorize_meter/useStore';
import { MetersTableMeter } from '../queries/getMetersTableData';
import { useCombinedMeters } from '../../../hooks/api/inventory-location/useCombinedMeters';
import { useStore } from '../useStore';
import { convertSortToEnmonFormat } from '../../../utils/convertSortToEnmonFormat';

interface MeterListContainer {
  meters: MetersTableMeter[];
  isLoading: boolean;
}

export const useMetersTable = (): MeterListContainer => {
  const { filter, pagination, updatePagination } = useStore();
  const { location } = useInventorizeStore();
  const { locationBuildings, buildingFloors, commodities, serialNumbers, sortField, sortOrder } = filter;
  const { pageSize, current, total } = pagination;

  const { data: { result: metersData } = {}, isFetching: isLoadingMeters } = useCombinedMeters(
    {
      id: location?.id,
      filter: {
        buildings: locationBuildings,
        buildingFloors,
        commodities,
        serial: serialNumbers?.[0] ?? undefined,
        sorts: convertSortToEnmonFormat(`${sortField}:${sortOrder}`),
        pageSize,
        page: current,
      },
    },
    {
      enabled: !!location?.id,
      onSuccess(data) {
        if (data.count !== total) updatePagination({ total: data.count });
      },
    },
  );

  if (!metersData) return { meters: [], isLoading: isLoadingMeters };

  return {
    meters: metersData ?? [],
    isLoading: isLoadingMeters,
  };
};
